import _debounce from 'lodash/debounce';

class ProjectSearch {
    constructor(
        inputSelector = '[data-project-search-input]',
        outputContainerSelector = '[data-project-search-output-container]',
        loadingIconSelector = '[data-project-search-loading-icon]',
        submitIconSelector = '[data-project-search-submit-icon]',
        projectSearchAPIUrl = '/api/projects'
    ) {
        this.inputSelector = inputSelector;
        this.outputContainerSelector = outputContainerSelector;
        this.loadingIconSelector = loadingIconSelector;
        this.submitIconSelector = submitIconSelector;

        this.inputElement = document.querySelector(this.inputSelector);
        this.outputContainerElement = document.querySelector(this.outputContainerSelector);
        this.loadingIconElement = document.querySelector(this.loadingIconSelector);
        this.submitIconElement = document.querySelector(this.submitIconSelector);

        this.projectSearchAPIUrl = projectSearchAPIUrl;

        // If one of these isn't present in the DOM, then this is not the place to search for projects
        if (!this.inputElement || !this.outputContainerElement || !this.loadingIconElement || !this.submitIconElement) {
            return;
        }

        this._init();
    }

    _init() {
        this.inputElement.addEventListener(
            'input',
            _debounce(() => {
                if (this.inputElement.value.length < 3) return;
                this._changeState(true);

                this._sendProjectSearchRequest(this.inputElement.value);
            }, 200)
        );
    }

    _sendProjectSearchRequest(searchValue) {
        fetch(this.projectSearchAPIUrl + '?search=' + searchValue, {
            method: 'GET',
        })
            .then((result) => result.json())
            .then((result) => {
                this._showResult(result.data);
                this._changeState(false);
            })
            .catch((error) => {
                console.error('Something went wrong while trying to search for a project', error);
            });
    }

    _showResult(result) {
        this.outputContainerElement.innerHTML = result;
    }

    _changeState(isSearching) {
        if (isSearching) {
            this.outputContainerElement.classList.add('animate-pulse');
            this.loadingIconElement.classList.remove('hidden');
            this.submitIconElement.classList.add('hidden');
        } else {
            this.outputContainerElement.classList.remove('animate-pulse');
            this.loadingIconElement.classList.add('hidden');
            this.submitIconElement.classList.remove('hidden');
        }
    }
}

new ProjectSearch();
